import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, tap } from 'rxjs/operators';
import * as holding from './holdings.actions';
import { concat, EMPTY, Observable, of } from 'rxjs';
import { from } from 'rxjs/internal/observable/from';
import { Holding, HoldingsRequestPayload, HoldingsFileRequestPayload } from './holdings.models';
import { HttpService } from '../../global/http.service';

import { downloadFile } from '../../global/fileDownload';
import { DatesIntervalRequest, DatesInterval } from '../../global/interfaces';
import { Actions as ActionsCDK } from "atlas-cdk";
import { ToastService } from '../../shared/toaster_/toaster_.service';

@Injectable()
export class HoldingsEffects {
  public loadHoldingsDates$ = createEffect(() => this.actions$.pipe(
    ofType<holding.LoadHoldingsDatesAction>(holding.ActionTypes.LOAD_HOLDINGS_DATES),
    map(action => action.payload),
    switchMap((payload: DatesIntervalRequest) =>
      this.loadHoldingsDates(payload).pipe(
        map((response: DatesInterval) =>
          new holding.LoadHoldingsDatesSuccessAction(response)
        ),
        catchError(error =>
          // from([
          //   new holding.LoadHoldingsDatesFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new holding.LoadHoldingsDatesFailedAction(error));
          // }
          concat(
            of(new holding.LoadHoldingsDatesFailedAction(error)),
            of(null).pipe(
              tap(() => {
                const errorMessage = (error?.error != null && error.error.message != null)
                  ? error.error.message
                  : error.message;
                this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  public loadHoldings$ = createEffect(() => this.actions$.pipe(
    ofType<holding.LoadHoldingsAction>(holding.ActionTypes.LOAD_HOLDINGS),
    map(action => action.payload),
    switchMap(payload =>
      this.loadHoldings(payload).pipe(
        map((response: Holding[]) =>
          new holding.LoadHoldingsSuccessAction(response)
        ),
        catchError(error =>
          // from([
          //   new holding.LoadHoldingsFailedAction(error),
          //   new AddErrorToastAction(error.error.message)
          // ])
          // {
          //   this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
          //   return of(new holding.LoadHoldingsFailedAction(error));
          // }
          concat(
            of(new holding.LoadHoldingsFailedAction(error)),
            of(null).pipe(
              tap(() => {
                const errorMessage = (error?.error != null && error.error.message != null)
                  ? error.error.message
                  : error.message;
                this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
              })
            )
          )
        )
      )
    )
  ));

  public holdingsDownload$ = createEffect(() => this.actions$.pipe(
    ofType<holding.HoldingsFileDownloadAction>(holding.ActionTypes.HOLDINGS_FILE_DOWNLOAD),
    map(action => action.payload),
    switchMap(payload =>
      this.downloadHoldingsFile(payload).pipe(
        map((response: any) => {
          const contentDisposition = response.headers.get('content-disposition'),
            filename = contentDisposition.split(';')[1].split('filename')[1]
              .split('=')[1].trim().replace(/"/g, '');
          // deepcode ignore DOMXSS:internally created secure response
          downloadFile(response.body, 'text/csv', `${filename}`);
        }),
        catchError(() => {
          // from([
          //   new AddErrorToastAction('Download failed. Please try again later.')
          // ])

          this._toasterService.launchAlertError('Download failed. Please try again later.', ActionsCDK.error);
          return EMPTY;
        }
        )
      )
    )
  ), { dispatch: false });

  public constructor(
    private readonly actions$: Actions,
    private readonly http: HttpService,
    private readonly _toasterService: ToastService
  ) {
  }

  private loadHoldingsDates(payload: DatesIntervalRequest): Observable<DatesInterval> {
    return this.http.get(`/metrics/${payload.account}/date-ranges/allocation`);
  }

  private loadHoldings(payload: HoldingsRequestPayload): Observable<Holding[]> {
    return this.http.post(`/holdings/accounts/${payload.account}`, {
      date: payload.date,
      country: payload.country,
      allocationType: payload.allocationType
    });
  }

  private downloadHoldingsFile(payload: HoldingsFileRequestPayload): Observable<any> {
    payload.type = 'csv';
    return this.http.post(`/holdings/accounts/${payload.account}/export`, payload, {
      observe: 'response',
      responseType: 'blob',
    });
  }
}
